/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_New_Term_AddedInputs */

const en_knp_terms_new_term_added = /** @type {(inputs: Knp_Terms_New_Term_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New term added`)
};

const fr_knp_terms_new_term_added = /** @type {(inputs: Knp_Terms_New_Term_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau terme ajouté`)
};

const de_knp_terms_new_term_added = /** @type {(inputs: Knp_Terms_New_Term_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Begriff hinzugefügt`)
};

const it_knp_terms_new_term_added = /** @type {(inputs: Knp_Terms_New_Term_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo termine aggiunto`)
};

const ru_knp_terms_new_term_added = /** @type {(inputs: Knp_Terms_New_Term_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавлен новый термин`)
};

const es_knp_terms_new_term_added = /** @type {(inputs: Knp_Terms_New_Term_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo término añadido`)
};

const zh_cn2_knp_terms_new_term_added = /** @type {(inputs: Knp_Terms_New_Term_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增术语`)
};

const ja_knp_terms_new_term_added = /** @type {(inputs: Knp_Terms_New_Term_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい用語が追加されました`)
};

const hi_knp_terms_new_term_added = /** @type {(inputs: Knp_Terms_New_Term_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया शब्द जोड़ा गया`)
};

const pt_pt2_knp_terms_new_term_added = /** @type {(inputs: Knp_Terms_New_Term_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo termo adicionado`)
};

/**
* | output |
* | --- |
* | "New term added" |
*
* @param {Knp_Terms_New_Term_AddedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_new_term_added = /** @type {((inputs?: Knp_Terms_New_Term_AddedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_New_Term_AddedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_new_term_added(inputs)
	if (locale === "de") return de_knp_terms_new_term_added(inputs)
	if (locale === "it") return it_knp_terms_new_term_added(inputs)
	if (locale === "ru") return ru_knp_terms_new_term_added(inputs)
	if (locale === "es") return es_knp_terms_new_term_added(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_new_term_added(inputs)
	if (locale === "ja") return ja_knp_terms_new_term_added(inputs)
	if (locale === "hi") return hi_knp_terms_new_term_added(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_new_term_added(inputs)
	return en_knp_terms_new_term_added(inputs)
});